import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTwitchMembershipsDiscountQuery = createQueryHook(
  MembershipsCreatorApiClient.getTwitchDiscount,
  {
    queryKey: ['twitchMembershipsDiscount'],
  },
)
